import React, { useState } from "react";
import {
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import { eliminarAsociacionCSC } from "../../helpers/api.helper";
import { MdOutlineDelete } from "react-icons/md";

const EliminarAsociacion = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const { asociacion, initAsociaciones, user } = props;

  const toast = useToast();

  const handleEliminarAsociacion = async () => {
    setLoading(true);
    let res = await eliminarAsociacionCSC({
      id: asociacion.idACSC,
    });
    if (res.status === 200) {
      toast({
        status: "success",
        isClosable: true,
        title: "Asociación eliminada correctamente",
        duration: 3000,
      });
      initAsociaciones();
      onClose();
    } else {
      toast({
        title: "Error al eliminar Asociación",
        description: res.data,
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Tooltip label="Eliminar Asociación" placement="left">
        <IconButton
          variant="link"
          icon={<MdOutlineDelete fontSize="20px" />}
          size="sm"
          onClick={onOpen}
          _hover={{ color: "brand.naranja" }}
        />
      </Tooltip>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        size="lg"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              color="brand.gris_primario"
              fontSize="lg"
              fontWeight="bold"
            >
              Eliminar Asociación
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Estás seguro que desea eliminar la Asociación{" "}
              <b>{asociacion.camion.dominio}</b> con{" "}
              <b>
                {asociacion.sandCube1
                  ? asociacion.sandCube1.nombreSandCube
                  : "-"}
              </b>{" "}
              y{" "}
              <b>
                {asociacion.sandCube2
                  ? asociacion.sandCube2.nombreSandCube
                  : "-"}
              </b>
              {asociacion.sandCube && (
                <b>
                  {asociacion.sandCube
                    ? asociacion.sandCube2.nombreSandCube
                    : "-"}
                </b>
              )}
              ?
              <br />
              Esta acción no se puede revertir.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="link" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                bg="brand.naranja"
                onClick={handleEliminarAsociacion}
                ml={3}
                isDisabled={loading || user.idRol === "usuarioIT"}
                color="white"
              >
                Eliminar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default EliminarAsociacion;
